export default __webpack_public_path__ + "static/media/IconSearchLarge.1e6581d3.svg";